<template>
    <b-modal id="floor_status" ref="floor_status" @hidden="resetModal"
             modal-class="modal-right modal-dialog-scrollable">
        <template v-slot:modal-title>
            <div>
                Update Status for<br>
                <div class="text-primary"> {{ floor.data.attributes.name }}</div>
            </div>
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-power-2 mr-3 menu-icon-style"/>

            <p class="my-auto">You can not change the status as INACTIVE if any unit(s) is/are
                occupied.
                Please discharge the client(s) from the unit(s) before INACTIVE the floor!
            </p>
        </div>

        <b-form>
            <b-row v-if="validationError" class="mb-2">
                <b-colxx md="12">
                    <b-alert class="text-center" show variant="danger"
                             v-text="validationError"/>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx xxs="12" class="mt-1 mb-2">
                    <span>Do you want to change the status? <sup><code>*</code></sup></span>
                </b-colxx>

                <b-colxx xxs="2" class="mb-2">
                    <toggle-button v-model="form.active" @input="'active' in errors ? (delete errors.active) : ''"
                                   :labels="{checked: 'YES', unchecked: 'NO'}" :height="28" :width="58"
                                   :color="{checked: '#28A745', unchecked: '#8F8F8F'}"/>
                </b-colxx>

                <b-colxx xxs="10" class="mb-2">
                    <h6>
                        <b-badge :variant="'outline-' + (form.active ? 'success' : 'danger')">
                            The Floor will be {{ form.active ? 'ACTIVE' : 'INACTIVE' }} after submission!
                        </b-badge>
                    </h6>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('floor_status')" v-text="'Cancel'"/>

            <template v-if="currentStatus === form.active">
                <b-button variant="primary" disabled v-text="'Submit'"/>
            </template>

            <template v-else>
                <state-button variant="primary" :click="submitFloorStatus">Submit</state-button>
            </template>
        </template>
    </b-modal>
</template>

<script>
    import {mapGetters} from "vuex";
    import Switches from 'vue-switches';
    import StateButton from "../../../../../components/Common/StateButton";

    export default {
        name: "FloorStatusModal",

        components: {
            Switches,
            StateButton
        },

        props: [
            'floor', 'currentStatus'
        ],

        data() {
            return {
                validationError: null
            }
        },

        computed: {
            ...mapGetters({
                form: 'getFloorStatusForm',
                errors: 'getFloorErrors',
            }),
        },

        methods: {
            submitFloorStatus() {
                let payload = {
                    floor_id: this.floor.floor_id,
                    form: {
                        ...this.form,
                    },
                };

                return new Promise((success, fail) => {
                    this.$store.dispatch('submitFloorStatus', payload)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                let newStatus = response.data.data.attributes.status.toLowerCase() === 'active';

                                this.$emit('updated', newStatus);

                                this.resetModal();

                                this.$notify('success filled', 'Success!', 'Status updated!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('floor_status');
                            }, 2000);
                        })
                        .catch(error => {
                            if (error.response.data.error) {
                                this.validationError = error.response.data.error;
                            }

                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                });
            },

            resetModal() {
                this.$store.commit('setFloorStatusForm');
                this.validationError = null;
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },
        },
    }
</script>

<style scoped>

</style>
